import { StyledDashboardLayout } from "./styled.dashboard";

export const DashboardLayout = ({ children }) => {
  return <StyledDashboardLayout>{children}</StyledDashboardLayout>;
};
